import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { globalTheme as GlobalColors } from '@playbookux/playbook-web-core';
import {
  Container,
  ContainerChart,
  ContainerColorDescription,
  ContainerDescription,
  DescriptionColor,
  DescriptionText,
  Header,
} from './styles';

import Barchart from '../../../../../../../core/components/charts/bar-chart';
// import this color from globals
const propertyMap = [
  { label: 'Direct success', propertyName: 'directSuccess', rgbColor: GlobalColors.color.directSuccess },
  { label: 'Indirect success', propertyName: 'indirectSuccess', rgbColor: GlobalColors.color.indirectSuccess },
  { label: 'Direct failure', propertyName: 'directFailure', rgbColor: GlobalColors.color.directFailure },
  { label: 'Indirect failure', propertyName: 'indirectFailure', rgbColor: GlobalColors.color.indirectFailure },
];

const Tasks = (props) => {
  const { tasks } = props;

  const dataStructure = useMemo(() => {
    const datasets = propertyMap.map((property) => ({
      label: property.label,
      backgroundColor: property.rgbColor,
      data: tasks.map((x) => x[property.propertyName].percentage),
      testers: tasks.map((x) => x[property.propertyName].total),
    }));

    return {
      labels: _.map(tasks, (task) => task.taskTitle),
      datasets,
    };
  }, [tasks]);

  const formatTitle = (text, maxLength) => {
    if (text.length <= maxLength) return text;

    let count = 0;
    let line = [];
    const words = [];
    const splitted = text.split(' ');

    splitted.forEach((word, idx) => {
      if (word.length + count <= maxLength) {
        count += word.length;
        if (!splitted[idx + 1]) {
          line.push(word);
          return words.push(line);
        }
        return line.push(word);
      }
      const aux = line;
      count = word.length;
      line = [word];
      return words.push(aux);
    });

    if (words.length > 3) {
      // get first 3 lines
      const newArray = words.slice(0, 3);
      newArray[2].push('...');
      return newArray.map((arrWords) => arrWords.join(' '));
    }

    return words.map((arrWords) => arrWords.join(' '));
  };

  const tooltips = {
    enabled: true,
    backgroundColor: GlobalColors.color.white,
    borderColor: GlobalColors.color.tooltipBorder,
    borderWidth: 2,
    displayColors: false,
    // Title config
    titleFontColor: GlobalColors.color.text,
    titleFontSize: 14,
    titleFontStyle: 'bold',
    // label config
    bodyFontColor: GlobalColors.color.text,
    bodyFontSize: 14,
    callbacks: {
      title: (ctx) => {
        const title = `${ctx[0].label}: ${tasks[ctx[0].index].label}`;
        return formatTitle(title, 40);
      },
      label: (ctx, data) => {
        const { datasets } = data;
        const { index, datasetIndex } = ctx;
        return `${datasets[datasetIndex].label} = ${datasets[datasetIndex].testers[index]} (${datasets[datasetIndex].data[index]}%)`;
      },
    },
  };

  return (
    <Container>
      <Header as="h3">Tasks</Header>
      <ContainerChart>
        <Barchart
          data={dataStructure}
          type="horizontal"
          stepSize={10}
          height={300}
          tooltips={tooltips}
          stacked
        />
        <ContainerDescription>
          <ContainerColorDescription>
            <DescriptionColor color={GlobalColors.color.directSuccess} />
            <DescriptionText>Direct success</DescriptionText>
          </ContainerColorDescription>

          <ContainerColorDescription>
            <DescriptionColor color={GlobalColors.color.indirectSuccess} />
            <DescriptionText>Indirect success</DescriptionText>
          </ContainerColorDescription>

          <ContainerColorDescription>
            <DescriptionColor color={GlobalColors.color.directFailure} />
            <DescriptionText>Direct failure</DescriptionText>
          </ContainerColorDescription>

          <ContainerColorDescription>
            <DescriptionColor color={GlobalColors.color.indirectFailure} />
            <DescriptionText>Indirect failure</DescriptionText>
          </ContainerColorDescription>
        </ContainerDescription>
      </ContainerChart>
    </Container>
  );
};

Tasks.propTypes = {
  tasks: PropTypes.arrayOf(
    PropTypes.shape({
      task_title: PropTypes.string,
      label: PropTypes.string,
      directSucess: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
      indirectSucess: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
      directFailure: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
      indirectFailure: PropTypes.shape({
        total: PropTypes.number,
        percentage: PropTypes.number,
      }),
    }),
  ).isRequired,
};

export default Tasks;
